// English comment: hangar filters and CSS classes expect lowercase size keys
export function normalizeHangarSize(size) {
  return String(size || '').trim().toLowerCase();
}
